module.exports = __webpack_public_path__ + "img/o.d0ac7757.jpg";